import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  LinearProgress,
  MenuItem,
  FormControlLabel,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import styles from './QAPhotoUploadDialogMenuItem.styles';
import { useDropzone } from 'react-dropzone';
import classnames from 'classnames';
import { AppContext } from '../../../../../AppContext';
import { OrderReviewContext, UPDATE_IMAGES } from '../../../OrderReviewContext';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

// SERVICES
import { saveAnswers, saveUploadedImages } from '../../../../../services';
import ReactSelect from 'react-select';
import { cloneDeep } from 'lodash';

const HoverSketchUploadDialog = ({ classes, onClose, open, orderFormHeaderId }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState(null);
  const [submitError, setSubmitError] = useState(null);
  const [files, setFiles] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(false);

  const { dispatch: appDispatch } = useContext(AppContext);
  const {
    state: { order, formHeaders, orderableFormHeaders },
    dispatch,
  } = useContext(OrderReviewContext);

  const { getRootProps, getInputProps } = useDropzone({
    accept: '.jpg, .jpeg',
    onDrop: acceptedFiles => {
      setFiles(
        acceptedFiles.map((file, fileIndex) => {
          const fileType = file.name.split('.').slice(-1);

          return Object.assign(file, {
            imageUri: URL.createObjectURL(file),
            fileName: `${new Date().getTime()}${fileIndex}.${fileType}`,
            label: null,
          });
        }),
      );
    },
  });

  const uploadPhotos = async () => {
    // add new images to the misc images array
    // then save to the backend which will generate IDs for the images

    const tempOrderForms = JSON.parse(JSON.stringify(formHeaders)).filter((fh) => fh.formHeaderId === 115);

    tempOrderForms.map(form => {
      form.formHeaderName = form.name;
    });

    // console.log(tempOrderForms);

    if (!tempOrderForms.length) {
      return console.log('no order forms to append to...');
    }

    // tempOrderForms[0].miscImages = tempOrderForms[0].miscImages ? tempOrderForms[0].miscImages.concat(...files) : files;

    try {
      setIsSubmitting(true);
      const newImages = await saveUploadedImages(tempOrderForms, order.id, files, orderFormHeaderId);

      dispatch({
        type: UPDATE_IMAGES,
        images: newImages,
      });

      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'success',
          message: 'Sketch uploaded successfully',
        },
      });
      window.location.reload();

      // clear state
      onClose();
    } catch (error) {
      console.log(error);
      appDispatch({
        type: 'SET_SNACKBAR',
        snackbar: {
          isOpen: true,
          variant: 'error',
          message: 'An error occurred while uploading your images... Please try again',
        },
      });
    }
    setIsSubmitting(false);
  };

  const handleRemoveFileFromPreview = file => {
    let newFiles = files.filter(f => f.fileName !== file.fileName);

    if (files.length === 1) {
      setFiles([]);
    } else {
      setFiles(newFiles);
    }
  };

  const renderThumb = (file, fileIndex) => (
    <>
      <div
        key={fileIndex}
        style={{ position: 'relative', display: 'inline-block', marginRight: 15, marginBottom: 15 }}
        onMouseEnter={() => setHoveredIndex(fileIndex)}
        onMouseLeave={() => setHoveredIndex(null)}
      >
        <img src={file.imageUri} style={{ maxWidth: 125 }} />
        {hoveredIndex === fileIndex && (
          <div
            style={{
              position: 'absolute',
              top: -5,
              right: -5,
              color: 'white',
              background: 'red',
              height: 20,
              width: 20,
              borderRadius: '100%',
            }}
            onClick={() => handleRemoveFileFromPreview(file)}
          >
            <CloseIcon style={{ fontSize: '20px' }} />
          </div>
        )}
      </div>
    </>
  );


  return (
    <React.Fragment>
      <Dialog
        open={open}
        fullWidth={true}
        maxWidth="lg"
        onClose={onClose}
        aria-labelledby="image-modal-title"
        className={classes.qaPhotoUploadDialog}
        autoScrollBodyContent={false}
        contentStyle={{ width: '100%', maxWidth: 'none' }}
      >
        <DialogTitle>Photo Hover Sketch</DialogTitle>
        <DialogContent>
          <main className={classnames('col-center-center', classes.container)}>
            <div {...getRootProps({ className: classes.dropzone })}>
              <input {...getInputProps()} />
              <p>Drag 'n' drop some files here, or click to select files</p>
            </div>
            <h2>Preview</h2>
            <div className={classnames('row-start-center')} style={{ flexWrap: 'wrap' }}>
              {!!files.length && files.map(renderThumb)}
              {!files.length && <div style={{ color: '#777' }}>Please add some photos above</div>}
            </div>
          </main>
        </DialogContent>
        <DialogActions
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <Button
            disabled={isSubmitting}
            onClick={onClose}
            variant="contained"
            style={{ backgroundColor: '#315382', color: 'white' }}
          >
            Cancel
          </Button>
          <div style={{ flex: 1, paddingLeft: 10, paddingRight: 10 }}>
            {isSubmitting && <LinearProgress />}
            {submitMessage && <div>{submitMessage}</div>}
            {submitError && <div style={{ color: 'red' }}>{submitError}</div>}
          </div>
          <Button
            disabled={isSubmitting}
            onClick={uploadPhotos}
            variant="contained"
            style={{ backgroundColor: '#315382', color: 'white' }}
          >
            Upload Photos
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

HoverSketchUploadDialog.defaultProps = {};
HoverSketchUploadDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default withStyles(styles)(HoverSketchUploadDialog);
